import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'
import { SystemSS } from '../../components/SystemSS'

export const ButtleFlowStep1 = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 0 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <section>
            <div className='flex justify-center '>
                <img
                    className=''
                    alt='gameflow button'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-step1.webp`}
                />
            </div>
            <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5 mx-auto mt-12'>
                <p className=' '>
                    At the start of combat, <span className='text-pborange'>Marona will be the only ally unit</span> on the map. Before you begin, there are a
                    few things you should check.
                </p>
                <ol className='list-outside list-number ml-8 text-pborange mt-4'>
                    <li>1. “What kinds of enemies are there?”</li> <li>2. “What items are there?”</li>{' '}
                    <li>3. “What objects can I Confine my allies in?”</li>
                </ol>
                <p className='mt-8'>
                    It is also useful to check the specifics of the map, such as whether the floor is made of slippery
                    ice, etc.
                </p>{' '}
                {/* <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-1',
                            index: 1,
                        },
                        {
                            modalId: 'flow-1',
                            index: 2,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description='Take a look at the map in cursor mode. Be sure to carefully gather your intel!'
                /> */}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-1',
                            index: 1,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description='Take a look at the map in cursor mode. Be sure to carefully gather your intel!'
                />
                <p className=' '>
                    When examining the map, you can also check <span className='text-pborange'>Protections</span>. Be sure to use these to your advantage in
                    battle, as well. Protection is represented by the characters and items that have a <span className='text-pborange'>glowing line </span>
                    to/from them. Characters and items joined by a glowing line are receiving the same <span className='text-pborange'>effect</span>. By
                    checking to see where the Protection is emanating to and from, you can put it to your strategic
                    advantage!
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-1',
                            index: 2,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                />
            </div>
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={2}
            />
        </section>
    )
}
